/* Copyright (c) 2026 Hyegro Pty Ltd. All rights reserved. */

/**
 * A record's flow (booking, mortgage, booking wizard steps).
 *
 * Legacy: the MUI Stepper the screens rendered inline before. UI v2: the
 * design's stage path (components/v2/StagePath), as components/CustomStepper
 * already does for CRM records. Neither is clickable.
 */

import React from 'react';
import PropTypes from 'prop-types';
import { Step, StepLabel, Stepper } from '@mui/material';
import StagePath from 'components/v2/StagePath';
import { useIsReV2 } from '../../v2/parts';

export default function ReStepper({ steps, activeStep }) {
  const isV2 = useIsReV2();
  if (isV2) return <StagePath steps={steps} activeStep={activeStep} />;
  return (
    <Stepper activeStep={activeStep} alternativeLabel>
      {steps.map((s) => <Step key={s}><StepLabel>{s}</StepLabel></Step>)}
    </Stepper>
  );
}

ReStepper.propTypes = {
  steps: PropTypes.arrayOf(PropTypes.string).isRequired,
  activeStep: PropTypes.number.isRequired,
};
